import { render } from "./OrganisationDashboard.vue?vue&type=template&id=023b7182"
import script from "./OrganisationDashboard.vue?vue&type=script&lang=js"
export * from "./OrganisationDashboard.vue?vue&type=script&lang=js"

import "./OrganisationDashboard.vue?vue&type=style&index=0&id=023b7182&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__